import React from 'react';
import css from './bfm.css';

const ANZFeed = ({ bankId, userid }) => {
    return (
        <div className={[css.w600, css.fontSmall].join(' ')}>
            <div className={css.dFlex}>
                <div className={[css.flex1, css.pt20, css.muted].join(' ')}><i className="far fa-file fa-3x"></i></div> 
                <div className={css.flex6}>
                    <p>To activate your ANZ bank feeds you’ll need to be logged into your ANZ Internet Banking.</p> 
                    <p>Then select Profile, and Manage bank feeds. If this is your first time setting up a bank feed, select Get started. Otherwise, select Activate a new bank feed. When asked for your Primary ID enter:</p>
                    <p className={css.textCenter}><strong>{userid}</strong></p>
                    <p>You do not need to enter a secondary id or email address.</p>
                    <p>{(bankId === 1) ? 
                        'Once this is done your feed will be displayed as active in the list of feeds on this page.'
                        : <strong>Once this is done click Add Feed again, select Connect Existing Feeds and select the Feed from the list of Feeds</strong>}</p>
                </div>
            </div>
        </div>
    );
};

export default ANZFeed;


// WEBPACK FOOTER //
// ./src/components/FeedManagment/ANZFeed.js